<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <img
        v-if="!visible"
        src="loading.gif"
        alt="carregando..."
        style="width: 30px; margin: 15px"
      />
      <v-alert v-if="visible" color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">
          {{ documento.tipoDocumento.nome }}
          {{ documento.numero }}/{{ documento.ano }}
        </h4>
      </v-alert>
      <v-form :disabled="!userHasPermission()" v-if="visible" v-model="valid" lazy-validation ref="form">
        <v-container>
          <v-row v-if="documento.html">
            <v-col>

              <v-btn color="primary" small depressed @click="abrirHtml()">
                <v-icon small left>fa-file-alt</v-icon>Visualizar
              </v-btn>

            </v-col>
          </v-row>

          <v-row v-if="documento.arquivo">
            <v-col>
              <v-btn color="primary" small depressed @click="download()">
                <v-icon small left>fa-download</v-icon>Download
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                type="number"
                label="Número"
                v-model="documento.numero"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                type="number"
                label="Ano"
                v-model="documento.ano"
              ></v-text-field>
            </v-col>

            <v-col md="4" style="margin-top: 1.1%">
              <v-select
                solo
                dense
                v-model="documento.tipoDocumento"
                :items="tiposDoc"
                item-text="nome"
                item-value="tipoDocumentoId"
                label="Tipo de Documento"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                return-object
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="11">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="ementaTextArea"
                label="Ementa"
                v-model="documento.ementa"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" >
              <ckeditor 
                :disabled="!userHasPermission()"
                class="document-editor border"
                @ready="onReady"
                :editor="editor"
                v-model="documento.html"
                :config="editorConfig"
              ></ckeditor>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="11">
              <v-file-input
                v-model="arquivoPdf"
                accept="application/pdf,.pdf"
                label="Arquivo PDF (opcional)"
                prepend-icon="mdi-file-pdf-box"
                show-size
                clearable
                persistent-hint
                :hint="
                  documento.arquivo
                    ? 'Já existe um PDF anexado. Escolher outro arquivo substitui o atual.'
                    : 'Para documentos sem HTML: ao abrir o documento no Mural, o PDF é baixado.'
                "
              ></v-file-input>
            </v-col>
          </v-row>

          <v-row style="margin-top: 2%">
            <v-radio-group v-model="documento.destino" row>
              <v-radio label="Interno" value="i"></v-radio>
              <v-radio label="Externo" value="e"></v-radio>
              <v-radio label="Ambos" value="a"></v-radio>
            </v-radio-group>
          </v-row>

          <v-row>
            <v-radio-group v-model="documento.status" row>
              <v-radio label="Vigente" value="Vigente"></v-radio>
              <v-radio label="Revogado" value="Revogado"></v-radio>
            </v-radio-group>
          </v-row>

          <v-row style="margin-top: 2%">
            <v-col cols="12" md="2">Palavras-Chave</v-col>
            <v-col cols="12" md="8" style="margin-top: -1.2%">
              <v-combobox
                v-model="documento.tags"
                chips
                clearable
                label="Palavras-Chave"
                multiple
                prepend-icon="mdi-filter-variant"
                solo
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    <strong>{{ item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                small
                depressed
                @click="salvar()"
                :disabled="!userHasPermission()"
                >Salvar</v-btn
              >
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                @click="sair()"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import documentoService from "@/service/DocumentoService";
import Documento from "@/model/documento";
import Editor from "ckeditor5-build-decoupled-document-base64-imageresize";
export default {
  data() {
    return {
      visible: false,
      editor: Editor,
      editorConfig: {},

      valid: false,
      documento: Documento(),
      arquivoPdf: null, // PDF escolhido no formulário, enviado depois de salvar o documento
      tiposDoc: [],
    };
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    validate() {
      this.$refs.form.validate();
    },
    remove(item) {
      this.documento.tags.splice(this.documento.tags.indexOf(item), 1);
      this.documento.tags = [...this.documento.tags];
    },
    abrirHtml() {
      if (this.documento.html != null && this.documento.html != "") {
        let rota = this.$router.resolve(
          "/documentohtml/" +
            this.documento.documentoId +
            "?compilado=true"
        );
        window.open(rota.href, "_blank");
      } else alert("Este documento não possui visualização HTML!");
    },
    download() {
      if (this.documento.arquivo) {
        documentoService.downloadArquivo(this.documento.documentoId);
      } else {
        alert("Este documento não possui arquivo para Download!");
      }
    },
    sair() {
      //this.$router.push("/documentos");
      if (this.$route.params.pagina === "legislacao") {
        this.$router.push("/documentos/legislacao");
      }
      if (this.$route.params.pagina === "doc") {
        this.$router.push("/documentos/doc");
      }
    },
    salvar() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        documentoService
          .salvar(this.documento)
          .then((result) => {
            if (!this.arquivoPdf) {
              (this.documento = result), alert("Documento Salvo!"), this.sair();
              return;
            }
            // o PDF vai em uma segunda chamada, já com o id do documento salvo
            const id = result ? result.documentoId : this.documento.documentoId;
            return documentoService
              .enviarArquivo(id, this.arquivoPdf)
              .then((comArquivo) => {
                this.documento = comArquivo;
                this.arquivoPdf = null;
                alert("Documento Salvo!");
                this.sair();
              })
              .catch((err) => {
                // o documento já foi gravado; fica na tela para tentar enviar o PDF de novo
                if (result) this.documento = result;
                alert(
                  "Documento salvo, mas o envio do PDF falhou: " +
                    this.mensagemDeErro(err) +
                    " Salve novamente para tentar de novo."
                );
              });
          })
          .catch((err) => alert(err.message));
      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },
    mensagemDeErro(err) {
      return (
        (err.response && err.response.data && err.response.data.message) ||
        err.message
      );
    },
  },

  mounted() {
    //created é chamado primeiro que mounted
  },
  created() {
    //documentoService.findTiposDocumento().then(res => this.tiposDoc = res);

    if (this.$route.params.pagina === "legislacao") {
      documentoService
        .findTiposLegislacao()
        .then((res) => (this.tiposDoc = res));
    }
    if (this.$route.params.pagina === "doc") {
      documentoService
        .findTiposDeliberacao()
        .then((res) => (this.tiposDoc = res));
    }

    if (this.$route.params.id != 0) {
      documentoService.buscarDocumento(this.$route.params.id).then((res) => {
        this.documento = res;
        this.visible = true;
      });
    } else {
      this.visible = true;
    }
  },
};
</script>

<style>
.document-editor {
  /* Set vertical boundaries for the document editor. */
  max-height: 400px;
}
/* .document-editor__toolbar .ck-toolbar {
    border: 1px solid;
    border-radius: 0;
} */
</style>